import axios from "axios";
import store from "redux/Store";

import {
  UPDATE_DOWNLOAD_LIST,
  ADD_DOWNLOADING_LIST,
  CLEAR_DOWNLOAD_LIST,
} from "./../Types";
import { AssetNotFoundReason } from "util/downloader/DownloadLink";

export const clearDownloads = () => (dispatch) => {
  dispatch({ type: CLEAR_DOWNLOAD_LIST });
}

export const updateDownloads = (payload, done = null) => (dispatch) => {
  const {
    download: { tracksDownloading, trackDownloads },
    user: {
      credentials: { orgID },
    },
  } = store.getState();

  let oData = { 
    id: payload.id,
    ...(payload.cfId && {cfId: payload.cfId}),
    ...(payload.plId && {plId: payload.plId}), 
    ...(payload.cfTrackSequenceId && {cfTrackSequenceId: payload.cfTrackSequenceId})
  }

  // if(payload.id){
  //   dispatch({ type: CLEAR_DOWNLOAD_LIST }); //added to remove the caching of the downloadeableassets. added due to CF share issues
  // }

  if (
    !trackDownloads.has(payload.id) &&
    !tracksDownloading.includes(payload.id)
  ) {
    dispatch({ type: ADD_DOWNLOADING_LIST, payload: oData });
    axios
      .post(
        `${orgID}/downloadeableassets`,
        oData,
        { headers: { orgid: orgID } }
      )
      .then((res) => {
          var downloads = { links: res?.data?.links ? res.data.links : [], reason: res?.data?.reason ? res.data.reason : ''};
          dispatch({
            type: UPDATE_DOWNLOAD_LIST,
            payload: { ...oData, downloads },
          });
          done && done();
      })
      .catch((err) => {
        dispatch({
          type: UPDATE_DOWNLOAD_LIST,
          payload: { ...oData, downloads: { links: [], reason: AssetNotFoundReason.exception } },
        });
        done && done();
      });
  }
};

export const getDownloadLinkByResolution = (id, resolution, searchId = null, plId = null, cfId = null) =>
new Promise(function (resolve, reject) {
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();
  axios
  .post(`${orgID}/downloadeablelink`, { id, resolution, ...(searchId && {searchId: searchId}), ...(plId && {plId : plId}), ...(cfId && {cfId: cfId})})
  .then((res) => {
      resolve(res?.data);
  })
  .catch((err) => {
    resolve('');
    });
});

export const getDownloadLinkByResolutionForDownload = (id, resolution, searchId = null, cfId = null, plId = null) =>
new Promise((resolve, reject) => {
  
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();

  axios
    .post(`${orgID}/downloadeablelink`,
     { id, resolution, ...(searchId && { searchId }), ...(plId && { plId }), ...(cfId && { cfId }) },
     { headers: { } }
     )
    .then((res) => {
      resolve(res?.data);
    })
    .catch((err) => {
      resolve('');
    });
});


export const getDownloadLink = (id, asset, searchId = null, plId = null, cfId = null, cfTrackSequenceId=null) =>
new Promise(function (resolve, reject) {
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();
  axios
  .post(`${orgID}/downloadeablelink`, { id, index: asset.index, ...(searchId && {searchId: searchId}), ...(plId && {plId : plId}), ...(cfId && {cfId: cfId}), ...(cfTrackSequenceId && {cfTrackSequenceId: cfTrackSequenceId}) })
  .then((res) => {
      //resolve(res?.data?.url ? res.data.url : '');
      resolve({url: res?.data?.url ? res.data.url : '', 
      ...(res?.data?.abuseFlag && {abuseFlag: res?.data?.abuseFlag}),
      ...(res?.data?.abuseMsg && {abuseMsg: res?.data?.abuseMsg})
      });
    });
});

export const getDownloadBookletLink = (id, asset) =>
new Promise(function (resolve, reject) {
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();
  axios
  .post(`${orgID}/downloadeablebooklet`, { id, index: asset })
  .then((res) => {
      resolve({url: res?.data?.url ? res.data.url : ''});
  })
  .catch((err) => {
    resolve('');
    });
});